import { trigger, state, animate, animateChild, group, style, transition, query } from '@angular/animations';

export function detailExpand() {
    return trigger('detailExpand', [
        state('collapsed', style({height: '0px', minHeight: '0'})),
        state('expanded', style({height: '*'})),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      ]);
}

export function rowAnimation() {
    return trigger('rowAnimation', [ transition('* => void', [ animate('0ms', style({ display: 'none'})) ]) ]);
}

